import { observable } from "mobx";
import { Type } from "class-transformer";
import ChargeVehicleRegistrationChangeRejectionReason from "./chargeVehicleRegistrationChangeRejectionReason";
import VehicleRegisterSynchronizationStatus from "./vehicleRegisterSynchronizationStatus";
import VehicleRegisterVehicleIdentificationResponse from "./vehicleRegisterVehicleIdentificationResponse";
import type VehicleRegistrationChangeWarningReason from "./vehicleRegistrationChangeWarningReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class VehicleChangePreviewResponse {
  /**
   * If true - change can be submitted.
   */
  @observable
  canBeSubmitted!: boolean;

  /**
   * Changed country ID.
   */
  @observable
  countryId!: string;

  /**
   * Changed license plate.
   */
  @observable
  licensePlate!: string;

  /**
   * Official record ID.
   */
  @observable
  officialRecordId!: string;

  /**
   * E-mail address.
   */
  @observable
  emailAddress?: string;

  @observable
  vehicleRegisterSynchronizationStatus!: VehicleRegisterSynchronizationStatus;

  @observable
  @Type(() => VehicleRegisterVehicleIdentificationResponse)
  vehicleRegisterVehicle?: VehicleRegisterVehicleIdentificationResponse;

  @observable
  newVehicleRegisterSynchronizationStatus!: VehicleRegisterSynchronizationStatus;

  @observable
  @Type(() => VehicleRegisterVehicleIdentificationResponse)
  newVehicleRegisterVehicle?: VehicleRegisterVehicleIdentificationResponse;

  @observable
  rejectionReason?: ChargeVehicleRegistrationChangeRejectionReason;

  /**
   * Warning reasons.
   */
  @observable
  warningReasons!: VehicleRegistrationChangeWarningReason[];
}
